import REFINANCE_COMPLETION_CONFIG from "../config/refinanceCompletionConfig";
import ChecklistPage from "./ChecklistPage";

// BM-H4191: remortgage and transfer of equity, for individuals and companies.
export default function RefinanceCompletionChecklist() {
  return <ChecklistPage config={REFINANCE_COMPLETION_CONFIG} checklistType="refinance_completion" />;
}
